import React from 'react';
import Labels from './Labels';

interface PhaserProps {
  activeFrame: any;
  phaseClasses: any;
  dicom: any;
  phaseLabels: any;
  setPhaseLabel: any;
}

const Phaser = ({ activeFrame, phaseClasses, dicom, phaseLabels, setPhaseLabel }: PhaserProps) => {
  return (
    <div>
      <Labels
        activeFrame={activeFrame}
        phaseClasses={phaseClasses}
        dicom={dicom}
        phaseLabels={phaseLabels}
        setPhaseLabel={setPhaseLabel}
      />
    </div>
  );
};

export default Phaser;
